/**
 * Base class for DTO's that holds the state of the object without
 * any modifications
 */
export class Entity {
    constructor(dto, keyId) {
        this._id = dto[keyId ?? "id"];
        this.dto = dto;
    }
    get id() {
        return this._id;
    }
    /**
     * @returns T - Raw data of this model
     */
    getDto() {
        return { ...this.dto };
    }
}
